import React from 'react';
import './ErrorScreen.css';

export default function ErrorScreen({ onRetry }) {
  return (
    <div className="error-screen">
      <div className="error-screen__icon">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="22" stroke="rgba(224,112,112,0.4)" strokeWidth="1.5"/>
          <path d="M24 14 L24 26" stroke="#E07070" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="24" cy="32" r="1.5" fill="#E07070"/>
        </svg>
      </div>
      <h2 className="error-screen__heading">Something went sideways.</h2>
      <p className="error-screen__body">
        Our server isn't responding right now. Find a booth team member — we'll capture your wish manually and get it sorted.
      </p>
      <button className="error-screen__retry" onClick={onRetry}>
        Try again
      </button>
    </div>
  );
}
